import WrongPinWarning from './wrong-pin-warning'

export default WrongPinWarning
